import { FormattedMessage } from 'react-intl'
import {
  Section,
  SectionContent,
  SectionHeader,
  SectionTitle,
  useFormValidation,
} from 'ui'
import type { RegularEffect as RegularEffectType } from '../../../../typings'
import { RegularBenefit } from '../../RegularForm/RegularEffect/Benefit'
import { RegularScope } from '../../RegularForm/RegularEffect/Scope'
import { useRestrictionsByBenefit } from '../../RegularForm/RegularEffect/useRestrictionsByBenefit'
import {
  benefitSuite,
  scopeSuite,
} from '../../RegularForm/RegularEffect/validation'
import { messages } from './messages'

type Props = {
  name: string
}

export function CampaignEffect(props: Props) {
  const { name } = props

  useRestrictionsByBenefit({
    name: `${name}.benefit.type`,
  })

  const validation = (config: RegularEffectType, { intl }) => {
    scopeSuite(intl, `${name}.scope`)(config['scope'])
    benefitSuite(intl, `${name}.benefit`)(config['benefit'])
  }

  useFormValidation('campaign-effect', {
    fieldName: name,
    validateFn: validation,
  })

  return (
    <Section>
      <SectionHeader>
        <SectionTitle>
          <FormattedMessage {...messages.title} />
        </SectionTitle>
      </SectionHeader>
      <SectionContent space="$space-10" fluid>
        <RegularScope name={`${name}.scope`} />
        <RegularBenefit name={`${name}.benefit`} />
      </SectionContent>
    </Section>
  )
}
